module.exports = __webpack_public_path__ + "img/Cigar2.5f77957d.jpg";